'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _recompose = require('recompose');

var _lodash = require('lodash');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _events = require('dom-helpers/events');

var _offset = require('dom-helpers/query/offset');

var _offset2 = _interopRequireDefault(_offset);

var _bound = require('./utils/bound');

var _bound2 = _interopRequireDefault(_bound);

var _percentage = require('./utils/percentage');

var _percentage2 = _interopRequireDefault(_percentage);

var _SliderHandle = require('./SliderHandle');

var _SliderHandle2 = _interopRequireDefault(_SliderHandle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var Slider = (_temp = _class = function (_Component) {
	_inherits(Slider, _Component);

	/**
  *
  */


	/**
  *
  */
	function Slider(props) {
		_classCallCheck(this, Slider);

		var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

		(0, _lodash.bindAll)(_this, 'handleClick', 'handleChange', 'handleDragStart', 'handleDrag', 'handleDragEnd');
		return _this;
	}

	/**
  *
  */


	/**
  *
  */


	_createClass(Slider, [{
		key: 'handleRef',
		value: function handleRef(index) {
			return 'handle-' + index;
		}

		/**
   *
   */

	}, {
		key: 'lowerBound',
		value: function lowerBound(index) {
			var _props = this.props;
			var values = _props.values;
			var min = _props.min;


			return index > 0 ? values[index - 1] : min;
		}

		/**
   *
   */

	}, {
		key: 'upperBound',
		value: function upperBound(index) {
			var _props2 = this.props;
			var values = _props2.values;
			var max = _props2.max;


			return values.length > index ? values[index + 1] : max;
		}

		/**
   *
   */

	}, {
		key: 'snapped',
		value: function snapped(value) {
			var step = this.props.step;

			return Math.round(value / step) * step;
		}

		/**
   *
   */

	}, {
		key: 'distance',
		value: function distance(index, point) {
			var handle = this.refs[this.handleRef(index)];
			var rect = (0, _offset2.default)((0, _reactDom.findDOMNode)(handle));

			return this.props.orientation === 'horizontal' ? Math.abs(rect.left - point.pageX) : Math.abs(rect.top - point.pageY);
		}

		/**
   *
   */

	}, {
		key: 'nearestHandle',
		value: function nearestHandle(point) {
			var _this2 = this;

			var nearest = this.props.values.reduce(function (previous, _, index) {
				var distance = _this2.distance(index, point);
				return distance < previous.distance ? { distance: distance, index: index } : previous;
			}, {
				distance: Infinity,
				index: 0
			});

			return nearest.index;
		}

		/**
   *
   */

	}, {
		key: 'moveTowardsPoint',
		value: function moveTowardsPoint(index, point) {
			var _props3 = this.props;
			var orientation = _props3.orientation;
			var min = _props3.min;
			var max = _props3.max;

			var rect = (0, _offset2.default)((0, _reactDom.findDOMNode)(this.refs.track));
			var ratio = orientation === 'horizontal' ? (0, _percentage2.default)(point.pageX - rect.left, rect.width) : (0, _percentage2.default)(point.pageY - rect.top, rect.height);

			var value = min + (max - min) / 100 * ratio;
			var snapped = this.snapped((0, _bound2.default)(value, this.lowerBound(index), this.upperBound(index)));

			this.handleChange(index, snapped);
		}

		/**
   *
   */

	}, {
		key: 'handleClick',
		value: function handleClick(event) {
			var values = this.props.values;

			var index = values.length > 1 ? this.nearestHandle(event) : 0;

			this.moveTowardsPoint(index, event);
		}

		/**
   *
   */

	}, {
		key: 'handleChange',
		value: function handleChange(index, newValue) {
			var _props4 = this.props;
			var values = _props4.values;
			var onChange = _props4.onChange;


			onChange(values.map(function (value, i) {
				return index === i ? newValue : value;
			}));
		}

		/**
   *
   */

	}, {
		key: 'handleDragStart',
		value: function handleDragStart(index) {
			var _this3 = this;

			this.setState({
				dragging: true,
				dragIndex: index
			}, function () {
				(0, _events.on)(document, 'mousemove', _this3.handleDrag);
				(0, _events.on)(document, 'mouseup', _this3.handleDragEnd);
			});
		}

		/**
   *
   */

	}, {
		key: 'handleDrag',
		value: function handleDrag(event) {
			event.preventDefault();
			this.moveTowardsPoint(this.state.dragIndex, event);
		}

		/**
   *
   */

	}, {
		key: 'handleDragEnd',
		value: function handleDragEnd() {
			var _this4 = this;

			this.setState({
				dragging: false
			}, function () {
				(0, _events.off)(document, 'mousemove', _this4.handleDrag);
				(0, _events.off)(document, 'mouseup', _this4.handleDragEnd);
			});
		}

		/**
   *
   */

	}, {
		key: 'render',
		value: function render() {
			var _this5 = this;

			var _props5 = this.props;
			var orientation = _props5.orientation;
			var values = _props5.values;

			var props = _objectWithoutProperties(_props5, ['orientation', 'values']);

			var className = (0, _classnames2.default)(['rea11y-Slider', 'rea11y-Slider--' + orientation, 'rea11y-Slider--' + values.length]);

			return _react2.default.createElement(
				'div',
				{ className: className },
				_react2.default.createElement(
					'div',
					{
						ref: 'track',
						className: 'rea11y-Slider-track',
						onClick: this.handleClick
					},
					values.map(function (value, index) {
						return _react2.default.createElement(_SliderHandle2.default, _extends({}, props, {
							ref: _this5.handleRef(index),
							key: index,
							index: index,
							value: value,
							lowerBound: _this5.lowerBound(index),
							upperBound: _this5.upperBound(index),
							onChange: _this5.handleChange,
							onDragStart: _this5.handleDragStart
						}));
					})
				)
			);
		}
	}]);

	return Slider;
}(_react.Component), _class.propTypes = {
	orientation: _react.PropTypes.string,
	min: _react.PropTypes.number,
	max: _react.PropTypes.number,
	step: _react.PropTypes.number,
	bigStep: _react.PropTypes.number,
	values: _react.PropTypes.array.isRequired,
	onChange: _react.PropTypes.func
}, _class.defaultProps = {
	orientation: 'horizontal',
	min: 0,
	max: 100,
	step: 1,
	bigStep: 10,
	values: [0],
	onChange: _lodash.noop
}, _temp);
exports.default = (0, _recompose.pure)(Slider);